<template>

    <Head title="Habilitese - Forum"></Head>

    <div class="card card-flush mb-10">
        <div v-if="show_erros.has_error">
            <div v-for="(message, index) in show_erros.messages" :key="index" class="alert alert-danger alert-dismissible d-flex flex-column flex-sm-row p-5 mb-5">
                <div class="d-flex flex-column">
                    <p>{{ show_erros.messages[index] }}</p>
                </div>
            </div>
        </div>
        <div class="m-5 pt-2">
            <div class="d-flex justify-content-center">
                <h1 class="mb-0 flex-grow-1">
                    {{ props.module.name.toUpperCase() }}
                </h1>
                <button class="btn btn-success" @click="newForumTopic()">
                    <i class="fas fa-plus"></i>
                    Criar Tópico
                </button>
            </div>
        </div>
    </div>
    <div v-for="content in props.forum_contents" :key="content.id">
        <div>
            <div class="card card-flush mb-5">
                <div>
                    <cardForum :content="{
                        first_name: content.first_name,
                        content: content.content,
                        isAdmin: is_admin,
                        contentAllowed: content.allowed,
                        contentId: content.id,
                        postUser: content.name.toUpperCase() === user_name.toUpperCase()

                    }" :urlAllowPost="props.urlAllowPost" :urlToDeletePost="props.urlToDeletePost" />
                </div>
                <div class="pt-0">
                    <div class="mb-6" v-for="response in content.response_content" :key="response.id">
                        <div v-if="is_admin || response.name.toUpperCase() === user_name.toUpperCase() || response.allowed">
                            <div class="separator separator-solid"></div>
                            <div class="separator separator-solid"></div>
                            <div :class="{ blockresponse: !response.allowed }">
                                <div>
                                    <cardForum :content="{
                                        first_name: response.first_name,
                                        content: response.content,
                                        isAdmin: is_admin,
                                        contentAllowed: response.allowed,
                                        contentId: response.id,
                                        postUser: response.name.toUpperCase() === user_name.toUpperCase()
                                    }" :urlAllowPost="props.urlAllowPost" :urlToDeletePost="props.urlToDeletePost" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="content.allowed" class="mx-10 ">
                        <div class="mt-15">
                            Responder este tópico
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="position-relative w-100">
                                <textarea :id="'text-area-' + content.id" v-model="resp[content.id]" type="text" class="form-control form-control-solid border border-gray-300 ps-5" rows="2" name="response" data-kt-autosize="true" placeholder="" style="overflow: hidden; overflow-wrap: break-word; resize: none; text-align: start; height: 50px;"></textarea>
                            </div>
                            <div class="m-3">
                                <button :disabled="!resp[content.id] || resp[content.id].trim() === ''" :id="content.id" class="btn btn-success" style="width: 110px; height: 50px;" @click="newResponseTopic(resp[content.id], content.id, content.url_to_response)">
                                    <i class="fas fa-paper-plane"></i>
                                    Enviar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup lang="ts">
import { Head, usePage } from '@inertiajs/vue3';
import { Module } from '../../Interfaces/Module';
import Swal from "sweetalert2";
import axios from 'axios';
import { Ref, ref } from 'vue';
import { router } from '@inertiajs/vue3';
import { AuthUser } from 'resources/js/Interfaces/AuthUser';
import cardForum from '../../components/Forum/cardForum.vue';
import { errors } from '../../stores/errors.ts'

export type RespContent = {
    id: string,
    name: string,
    first_name: string,
    user_id: number,
    content: string,
    allowed: boolean,
    sequence: number,
}

export type Content = {
    id: string,
    user_id: number,
    name: string,
    first_name: string,
    content: string,
    allowed: boolean,
    response_content: Array<RespContent>
    url_to_response: string,
}

const auth_user = usePage().props?.auth_user as AuthUser;
const user_name = auth_user.user_name;

const props = defineProps({
    module: { type: Object as () => Module, required: true },
    forum_contents: { type: Array<Content>, required: true },
    urlToPostNewTopic: { type: String, required: true },
    urlAllowPost: { type: String, required: true },
    urlAllowResponse: { type: String, required: true },
    is_admin: { type: Boolean, required: true },
    urlToDeletePost: { type: String, required: true }
})

const show_erros = errors();

var resp: Ref<Array<string>> = ref([]);

function newForumTopic() {
    show_erros.delete_messages();
    Swal.fire({
        title: "Criar novo Topico",
        text: "Descreva sua duvida",
        input: "textarea",
        inputValidator: (value) => {
            if (!value) {
                return "Se não possuir duvida é so cancelar";
            }
            return null;
        },
        showCancelButton: true,
        confirmButtonText: "Postar",
        confirmButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#3085d6",
    }).then((result) => {
        if (!result.isConfirmed) {
            return;
        }
        axios.post(
            props.urlToPostNewTopic,
            {
                module_id: props.module.id,
                content: result.value
            }
        ).then(function (res) {
            show_erros.set_has_errors(false);
            router.reload({
                only: ['forum_contents'],
            });
        }).catch(function (err) {
            console.log(err.response.data.message);
            show_erros.set_has_errors(true);
            show_erros.set_messages(err.response.data.message);

        });
    });
}

async function newResponseTopic(content: string, id: string, url: string) {
    const btnElement = document.getElementById(id);
    show_erros.delete_messages();

    if (btnElement) {
        btnElement.classList.add('disabled');
        btnElement.innerHTML = `
            <i class="fa fa-spinner fa-spin"></i>
        `;
    }

    if (content === undefined) {
        if (btnElement) {
            btnElement.classList.remove('disabled');
            btnElement.innerHTML = 'Enviar';
        }
        return;
    }
    await axios.post(
        url,
        {
            content: content,
            content_id: id
        }
    ).then(function (res) {
        router.reload({
            only: ['forum_contents'],
        });
        show_erros.set_has_errors(false);

    }).catch(function (err) {
        console.log(err.response.data.message);
        show_erros.set_has_errors(true);
        show_erros.set_messages(err.response.data.message);
    });
    if (btnElement) {
        btnElement.classList.remove('disabled');
        btnElement.innerHTML = 'Enviar';
    }

}
</script>

<style>
.blockcontent,
.blockresponse {
    background-color: rgba(22, 212, 5, 0.281);
    pointer-events: none;
    z-index: 10;
}


.btn-filtro {
    pointer-events: visible;
}
</style>
